import * as React from 'react';
import {useSelector} from 'react-redux';
import {Route, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {App} from '../../app/index';
import type {NutshellState} from '../../store';

import {RefreshingPage} from './refreshing-page';

type OwnProps = JSX.LibraryManagedAttributes<typeof Route, React.ComponentProps<typeof Route>>;

type Props = OwnProps & ContextRouter;

function RefreshingRouteComponent(props: Props) {
    const {render, ...routeProps} = props;
    const appVersion = useSelector((state: NutshellState) => App.getAppVersion(state));

    if (!render) return null;
    const newVersionAvailable = Boolean(
        appVersion &&
            NutshellFrontendSettings.appVersion &&
            appVersion !== NutshellFrontendSettings.appVersion
    );

    return (
        <Route
            {...routeProps}
            render={(renderProps) => (
                <RefreshingPage
                    pathname={routeProps.location.pathname}
                    shouldRefresh={newVersionAvailable}
                >
                    {render(renderProps)}
                </RefreshingPage>
            )}
        />
    );
}

// @ts-expect-error
export const RefreshingRoute = withRouter<OwnProps>(RefreshingRouteComponent);
